import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

const CHIAVE = 'avviso_quote_visto';

const leggi = () => { try { return sessionStorage.getItem(CHIAVE) === '1'; } catch (e) { return false; } };
const scrivi = () => { try { sessionStorage.setItem(CHIAVE, '1'); } catch (e) { /* niente */ } };

// Avviso che il condomino trova a ogni accesso: i dati delle quote sono in verifica e va segnalata ogni differenza.
// Si chiude solo con uno dei due pulsanti; riappare al prossimo accesso (la chiave si azzera al login).
export const AvvisoQuoteCondomino = () => {
  const { user, selectedCondominium, accessoComeCondomino } = useAuth();
  const navigate = useNavigate();
  const [aperto, setAperto] = useState(false);
  // aspetta che il condomino abbia letto e accettato l'informativa privacy (finestra InformativaPrivacyCondomino)
  const [pronto, setPronto] = useState(Boolean(window.__informativaOk));
  useEffect(() => { const h = () => setPronto(true); window.addEventListener('informativa-ok', h); return () => window.removeEventListener('informativa-ok', h); }, []);
  const eCondomino = selectedCondominium?.role === 'RESIDENT';

  useEffect(() => {
    // non sopra la schermata obbligatoria del cambio password (con «entra come» quella schermata non c'e': l'amministratore vede l'app com'e')
    if (eCondomino && pronto && user && (accessoComeCondomino || !user.force_password_change) && !leggi()) setAperto(true);
  }, [eCondomino, pronto, user, accessoComeCondomino]);

  if (!eCondomino) return null;

  const chiudi = () => { scrivi(); setAperto(false); };
  const scrivi_segnalazione = () => { scrivi(); setAperto(false); navigate('/bacheca-condomini?nuova=segnalazione'); };

  return (
    <Dialog open={aperto} onOpenChange={() => { /* si chiude solo con i pulsanti */ }}>
      <DialogContent className="max-w-lg" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-600" /> Controlla la tua posizione
          </DialogTitle>
          <DialogDescription className="sr-only">Avviso sulla correttezza dei dati delle quote</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm leading-relaxed">
          <p>
            Le quote e i pagamenti che vedi in questa piattaforma sono ancora in fase di verifica. In alcuni casi potrebbero mancare
            dei dati o non essere del tutto esatti.
          </p>
          <p>
            Se trovi una differenza, un pagamento che non risulta o un importo che non ti torna, a tuo debito o a tuo credito,
            scrivici subito con una <strong>segnalazione</strong> da qui. Se hai la prova dei pagamenti che risultano non versati
            (ricevuta, bonifico, estratto conto), <strong>allegala</strong>: ci aiuta a correggere più in fretta.
          </p>
          <p>Grazie per la collaborazione.</p>
        </div>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={chiudi}>Ho capito, continua</Button>
          <Button onClick={scrivi_segnalazione}>Scrivi una segnalazione</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AvvisoQuoteCondomino;
